import { Country } from '../types/todo';

const API_ID_BASE_URL = import.meta.env.VITE_API_ID_BASE_URL;

const CACHE_DURATION = 60 * 60 * 1000; // (1 hour)

// In-memory cache
let countriesCache: {
  data: Country[] | null;
  timestamp: number;
  expiryTime: number;
} = {
  data: null,
  timestamp: 0,
  expiryTime: CACHE_DURATION,
};

/**
 * Get cached countries data from the ID API
 * This serves as a cache for Firestore countries data
 * Implements in-memory caching to minimize API calls
 */
export const getCachedCountries = async (): Promise<Country[]> => {
  // Check if we have valid cached data
  const now = Date.now();
  if (
    countriesCache.data && 
    countriesCache.data.length > 0 && 
    now - countriesCache.timestamp < countriesCache.expiryTime
  ) {
    console.log('Using in-memory countries cache');
    return countriesCache.data;
  }

  try {
    console.log('Fetching countries from API cache');
    const response = await fetch(`${API_ID_BASE_URL}/fs/cache/countries`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json() as Country[];
    
    // Update the cache
    countriesCache = {
      data,
      timestamp: now,
      expiryTime: countriesCache.expiryTime
    };
    
    return data;
  } catch (error) {
    console.error('Error fetching cached countries:', error);
    throw error;
  }
};